/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleChanges: {
        id: 'cep.components.sgEndorsementChangesInfo.VehicleChanges',
        defaultMessage: 'Car changes'
    },
    DriverChanges: {
        id: 'cep.components.sgEndorsementChangesInfo.DriverChanges',
        defaultMessage: 'Driver changes'
    },
    CoverOptionChanges: {
        id: 'cep.components.sgEndorsementChangesInfo.CoverOptionChanges',
        defaultMessage: 'Cover option changes'
    },
    VehicleChange: {
        id: 'cep.components.sgEndorsementChangesInfo.VehicleChange',
        defaultMessage: 'Changed car to:'
    },
    RegChange: {
        id: 'cep.components.sgEndorsementChangesInfo.RegChange',
        defaultMessage: 'You changed your car registration number to:'
    },
    OnExistingVehicle: {
        id: 'cep.components.sgEndorsementChangesInfo.OnExistingVehicle',
        defaultMessage: 'On your existing vehicle:'
    },
    ExistingVehicle: {
        id: 'cep.components.sgEndorsementChangesInfo.ExistingVehicle',
        defaultMessage: '{make} {model}'
    },
    ModificationAdded: {
        id: 'cep.components.sgEndorsementChangesInfo.ModificationAdded',
        defaultMessage: 'Added modification:'
    },
    ModificationRemoved: {
        id: 'cep.components.sgEndorsementChangesInfo.ModificationRemoved',
        defaultMessage: 'Removed modification:'
    },
    MileageChange: {
        id: 'cep.components.sgEndorsementChangesInfo.MileageChange',
        defaultMessage: 'Change mileage to:'
    },
    VehicleUseChange: {
        id: 'cep.components.sgEndorsementChangesInfo.VehicleUseChange',
        defaultMessage: 'Changed use of car to:'
    },
    VehicleParkingChange: {
        id: 'cep.components.sgEndorsementChangesInfo.VehicleParkingChange',
        defaultMessage: 'Changed parking type to:'
    },
    DriverAdded: {
        id: 'cep.components.sgEndorsementChangesInfo.DriverAdded',
        defaultMessage: 'Driver added:'
    },
    AlternativeAddress: {
        id: 'cep.components.sgEndorsementChangesInfo.AlternativeAddress',
        defaultMessage: 'Is the vehicle going to be kept at an alternative address? If it is, please call us on {phoneNumber} to ensure you are fully covered'
    },
    DriverRemoved: {
        id: 'cep.components.sgEndorsementChangesInfo.DriverRemoved',
        defaultMessage: 'Removed driver:'
    },
    CoverageAdded: {
        id: 'cep.components.sgEndorsementChangesInfo.CoverageAdded',
        defaultMessage: 'Added:'
    },
    CoverageRemoved: {
        id: 'cep.components.sgEndorsementChangesInfo.CoverageRemoved',
        defaultMessage: 'Removed:'
    },
    Changed: {
        id: 'cep.components.sgEndorsementChangesInfo.Changed',
        defaultMessage: 'Changed:'
    },
    BreakdownCoverChanged: {
        id: 'cep.components.sgEndorsementChangesInfo.BreakdownCoverChanged',
        defaultMessage: 'Saga Breakdown Assistance - level of cover changed to {coverLevel}'
    },
    VoluntaryExcessChanged: {
        id: 'cep.components.sgEndorsementChangesInfo.VoluntaryExcessChanged',
        defaultMessage: 'Voluntary Accidental Damage Excess changed to {excess}'
    },
    PNCDPriceChanged: {
        id: 'cep.components.sgEndorsementChangesInfo.PNCDPriceChanged',
        defaultMessage: 'Price has changed for PNCD to £{amount}'
    },
    ExcessTableHeader: {
        id: 'cep.components.sgEndorsementChangesInfo.ExcessTableHeader',
        defaultMessage: 'As a result of today\'s changes your {compulsory} accidental damage excess will change to: £{excess}'
    },
    ExcessTableHeaderFT: {
        id: 'cep.components.sgEndorsementChangesInfo.ExcessTableHeaderFT',
        defaultMessage: 'As a result of today\'s changes your Fire & Theft excess will change to: £{excess}'
    },
    VoluntaryExcess: {
        id: 'cep.components.sgEndorsementChangesInfo.VoluntaryExcess',
        defaultMessage: 'Voluntary Excess'
    },
    CompulsoryExcess: {
        id: 'cep.components.sgEndorsementChangesInfo.CompulsoryExcess',
        defaultMessage: 'Compulsory Excess'
    },
    TotalExcess: {
        id: 'cep.components.sgEndorsementChangesInfo.TotalExcess',
        defaultMessage: 'Total Excess'
    },
    Header: {
        id: 'cep.components.sgEndorsementChangesInfo.Header',
        defaultMessage: 'As a result of today\'s changes your accidental damage excess will change to: '
    }
});
